import { yup } from '@framework/validation/initYup.ts';
import { type IPickableColumn } from '../IPickableColumn.tsx';

export const ColumnPickerItemSchema: yup.ObjectSchema<IPickableColumn> = yup
  .object({
    id: yup.string().required(),
    index: yup.number().required(),
    key: yup.string().required(),
    visible: yup.boolean(),
    fixed: yup.boolean(),
    showInExpandedRow: yup.boolean(),
    // fixable: yup.boolean(),
  })
  .noUnknown()
  .required();

export const ColumnPickerSchema = yup.object({
  columns: yup.array().of(ColumnPickerItemSchema).default([]).required(),
});

export type ColumnPickerConfig = yup.InferType<typeof ColumnPickerSchema>;
